import React from 'react';
import PropTypes from 'prop-types';

const secondaryAdComponent = ({ adName, type }) => {
	let className = `secondary-ad ${ type }_secondary-ad`;

	return (
		<iframe id={ `SecondaryAd_${ adName }` } className={ className } scrolling="no" />
	);
};

secondaryAdComponent.propTypes = {
	adName: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired
};

export default secondaryAdComponent;



// WEBPACK FOOTER //
// ./src/components/ads/secondaryAdComponent.js